import { forwardRef } from "react";
import { CoreTypography, CoreTooltipIconButton } from "@boi/components-core";

import * as S from "./InlineTooltipIconButton.styled";
import {
  TooltipIconButton,
  type TooltipIconButtonProps,
} from "../TooltipIconButton";

export type InlineTooltipIconButtonProps = TooltipIconButtonProps & {
  typographyVariant?: CoreTypography.Variant;
};

const InlineTooltipIconButton = forwardRef<
  HTMLButtonElement,
  InlineTooltipIconButtonProps
>((props, ref) => {
  const {
    variant = CoreTooltipIconButton.DEFAULT_VARIANT,
    typographyVariant = CoreTypography.DEFAULT_VARIANT,
    ...tooltipIconButtonProps
  } = props;

  return (
    <S.Wrapper $variant={variant} $typographyVariant={typographyVariant}>
      <TooltipIconButton
        ref={ref}
        variant={variant}
        {...tooltipIconButtonProps}
      />
    </S.Wrapper>
  );
});

TooltipIconButton.displayName = "InlineTooltipIconButton";

export default InlineTooltipIconButton;
